import { render, staticRenderFns } from "./vueComponentBuilder.vue?vue&type=template&id=b12e339c&scoped=true"
import script from "./vueComponentBuilder.vue?vue&type=script&lang=js"
export * from "./vueComponentBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12e339c",
  null
  
)

export default component.exports